import * as Types from './types';
import { createAction } from '../utils';

export const reset = () => createAction(Types.RESET);
// act on a single budget instance identified by guid
export const updateFormValue = (
    guid: string,
    category: Types.BudgetCategory | Types.LandBudgetCategory | Types.FixFlipBudgetCategory | Types.SpecSheetCategory,
    valueName: string,
    value: Types.FormRecordValueType
) => createAction(Types.UPDATE_VALUE, { guid, category, valueName, value });
export const updateFormName = (guid: string, name: string) => createAction(Types.UPDATE_NAME, { guid, name });
export const updateFormIsDirty = (guid: string, isDirty: boolean) => createAction(Types.UPDATE_FORM_IS_DIRTY, { guid, isDirty });
export const replaceFormState = (guid: string, state: Types.FormState) => createAction(Types.REPLACE_FORM_STATE, { guid, state });

// act on the budget collection
export const addEmptyForm = (type: Types.FormType, guid: string, name: string) =>
    createAction(Types.ADD_EMPTY_FORM, { type, guid, name });
export const deleteForm = (guid: string) => createAction(Types.DELETE_FORM, { guid });
export const cloneForm = (sourceGuid: string, destinationGuid: string, name: string) =>
    createAction(Types.CLONE_FORM, { sourceGuid, destinationGuid, name });
export const updateCollectionIsDirty = (isDirty: boolean, apiId: string) =>
    createAction(Types.UPDATE_COLLECTION_IS_DIRTY, { isDirty, apiId });
export const replaceCollectionState = (state: Types.FormCollectionState) =>
    createAction(Types.REPLACE_COLLECTION_STATE, { state });

export type FormActionReturns =
    | ReturnType<typeof reset>
    | ReturnType<typeof updateFormValue>
    | ReturnType<typeof updateFormName>
    | ReturnType<typeof addEmptyForm>
    | ReturnType<typeof deleteForm>
    | ReturnType<typeof updateCollectionIsDirty>
    | ReturnType<typeof updateFormIsDirty>
    | ReturnType<typeof replaceCollectionState>
    | ReturnType<typeof replaceFormState>
    | ReturnType<typeof cloneForm>;
